<i18n src="./resources/locales.json"></i18n>

<template>
  <div>
    <EcsSearchInput
      ref="searchBox"
      class="pa-4"
      :sync="syncSearch"
      :placeholder="searchPlaceholder"
      @search-input-changed="handleSearch"
    />
    <slot name="toolbar"></slot>
    <div ref="listContainer" class="custom-scrollbar side-bar-list-container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EcsSideBarWrapper',

  props: {
    isLoadingData: {
      type: Boolean,
      default: false
    },
    searchPlaceholder: {
      type: String,
      default: ''
    },
    syncSearch: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      collapseOpened: false,
      previousScrollTop: 0
    };
  },

  methods: {
    handleSearch(value) {
      this.$emit('search-input-changed', value);
    }
  }
};
</script>

<style scoped>
.side-bar-list-container {
  height: calc(100vh - 134px);
}

.wallboard-menu-container .side-bar-list-container {
  height: calc(100vh - 158px);
}
</style>
